import { Utility } from './../../../shared/utility';
import { EditAdjRecords } from './../../../models/adjustment';
import { ScheduleService } from './../../../shared/services/pay-schedules/schedule.service';
import { AuthService } from './../../../shared/services/auth/auth.service';
import { AdjustmentService } from 'src/app/shared/services/adjustments/adjustment.service';
import { UsersService } from './../../../shared/services/common/users.service';
import { ReadConfigService } from './../../../shared/services/common/read-config.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UploadEvent, SuccessEvent, SelectEvent, UploadProgressEvent } from '@progress/kendo-angular-upload';
import { AdjustmentFileData, AdjustmentRecord } from 'src/app/models/adjustment';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-create-adjustment-report',
  templateUrl: './create-adjustment-report.component.html',
  styleUrls: ['./create-adjustment-report.component.css']
})
export class CreateAdjustmentReportComponent implements OnInit {
  adjustmentInputData: any;
  summaryData: any;
  config: any;
  operators: any;
  adjModelDataItem: any;
  saveForLaterMsg: any;
  payrollAdjId: any;
  editAdjDataItem: any;
  fileErrorMsg: any;
  ssnValue: any;
  yearArray: any;
  allFiscalYears: any;
  selectedFYSchedules: any;
  gridData: any;
  noContectMsg: any;
  selectedElements = [];
  isError = false;
  savedAdjustmentId: number;
  adjustmetRecordId: number;
  ssn: number;
  adjutmentsId: number;
  submitAdjDialog: boolean;
  loading: boolean;
  createAdjDialog: boolean;
  isNew: boolean;
  saveForLaterDialog: boolean;
  isFileError: boolean;
  isNextVisible: boolean;
  ssnVerifiationDialog: boolean;
  isEmpDetailValid = false;
  maxErrorExceeded = false;
  searchBtnEnable: boolean;
  empNotFound: boolean;
  isProcessing = false;
  disableClose = false;
  personalDetailsForm: UntypedFormGroup;
  ssnMask = '000-00-0000';
  ssnPattern = /^(?!666|000\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
  fileNameErrorMsg = '';
  msg = '';
  inputData: { userInfo: any; };
  readonly uploadRemoveUrl: string = 'removeUrl';
  uploadSaveUrl: string;
  enableMasterDeleteBtn: boolean;
  enableInvalidDeleteBtn: boolean;
  deleteMasterAdjDialog: boolean;

  isEditInvalidAdj: boolean;
  editAdjData: any;

  selectedData = [];
  panelbarData = [
    { panel: 0, name: 'Invalid', load: true, expanded: false, id: 'invalid' },
    { panel: 1, name: 'Errored', load: true, expanded: false, id: 'error' },
    { panel: 2, name: 'Validated', load: true, expanded: false, id: 'valid' }
  ];
  expandMode = PanelBarExpandMode.Multiple;
  invalidAdjData = [];
  errorAdjData = [];
  validAdjData = [];
  @Input() set adjustmentDataItem(adjData: any) {
    this.editAdjDataItem = {};
    if (adjData && adjData.isRejectedRecord) {
      this.editAdjDataItem = adjData;
    } else {
      this.editAdjDataItem = (adjData && adjData.action === 'edit') ? adjData : '';
    }
  }
  @Output() isDataSaved: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private adjustmentService: AdjustmentService,
    private scheduleService: ScheduleService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit() {
    this.config = this.readConfigService.getAdjustmentv2Text();
    this.operators = this.authService.getAccessOperations(2);
    this.notificationService.setUpLoading(true);
    this.inputData = {
      userInfo: this.usersService.UserInfo()
    };
    this.getAdjustmentLocSys();
    this.getAdjustmentRecords(false);
    this.uploadSaveUrl = this.adjustmentService.getAdjUploadUrl();
    this.panelbarData.forEach((element: any) => {
      if (element.name === 'Validated') {
        element.expanded = true;
      }
    });
  }

  onPanelChange(event: any): void {
    if (event) {
      const currPanel = this.panelbarData[event.items.find((item: any) => item.selected).id];
      if (currPanel.load) {
        const data = JSON.parse(JSON.stringify(currPanel));
        // TODO LOAD REQUIRED DATA
        // this.notificationService.setUpLoading(true);
        currPanel.load = false;
      }
    }
  }

  getPersonalDetailForm() {
    this.personalDetailsForm = new UntypedFormGroup({
      ssn: new UntypedFormControl('', [Validators.required, Validators.pattern(this.ssnPattern)]),
      fiscalYear: new UntypedFormControl('', [Validators.required]),
    });
  }

  getAdjustmentLocSys() {
    this.adjustmentService.getAdjustmentInputs(this.inputData).subscribe(response => {
      if (response && response.success) {
        if (response.locations && response.locations.length > 0) {
          response.locations.forEach(element => {
            element.name = element.code.concat('-', element.name);
          });
        }
        this.adjustmentInputData = response;
      } else {
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      }
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  getAdjustmentRecords(isCreated: any) {
    this.summaryData = {};
    const adjustmentRecordId = this.editAdjDataItem.isRejectedRecord ? this.savedAdjustmentId = this.editAdjDataItem.adjId : (this.editAdjDataItem && this.editAdjDataItem.action === 'edit') ?
      this.savedAdjustmentId = this.editAdjDataItem.dataItem.id : (isCreated ? this.savedAdjustmentId : 0);
    const inputData = { userInfo: this.usersService.UserInfo(), adjustmentId: adjustmentRecordId };
    this.adjustmentService.getAdjustmentV2Records(inputData).subscribe(response => {
      if (response && response.statusCode === 200 && response.adjMetaData) {
        if (response.erroredAdjustment && response.erroredAdjustment.length > 0) {
          this.adjutmentsId = response.erroredAdjustment[0].payrollAdjustmentsId;
        } else if (response.invalidAdjustment && response.invalidAdjustment.length > 0) {
          this.adjutmentsId = response.invalidAdjustment[0].payrollAdjustmentsId;
        } else {
          this.adjutmentsId = response.validAdjustment[0].payrollAdjustmentsId;
        }
        this.summaryData = {
          adjustmentId: this.adjutmentsId,
          totalRecords: response.adjMetaData[0].totalRecords,
          totalErrorRecords: response.adjMetaData[0].totalErrorRecords,
          totalContributions: response.adjMetaData[0].totalContributions,
          formatContribution: Utility.checkNegativeAmount(response.adjMetaData[0].totalContributions)
        };
        if (response.invalidAdjustment && response.invalidAdjustment.length > 0) {
          this.isError = response.invalidAdjustment.some(x => x.errorCount > 0);
          response.invalidAdjustment.forEach((element: any) => {
            element.lastFourSSN = element.ssn.substr(5);
          });
          this.invalidAdjData = response.invalidAdjustment;
          this.panelbarData[0].expanded = true;
        } else {
          this.invalidAdjData = [];
        }

        if (response.erroredAdjustment && response.erroredAdjustment.length > 0) {
          this.isError = response.erroredAdjustment.some(x => x.errorCount > 0);
          response.erroredAdjustment.forEach((element: any) => {
            element.lastFourSSN = element.ssn.substr(5);
          });
          this.errorAdjData = response.erroredAdjustment;
          this.panelbarData[1].expanded = true;
        } else {
          this.errorAdjData = [];
        }

        if (response.validAdjustment && response.validAdjustment.length > 0) {
          this.isError = false;
          response.validAdjustment.forEach((element: any) => {
            element.lastFourSSN = element.ssn.substr(5);
          });
          this.validAdjData = response.validAdjustment;
          this.panelbarData[2].expanded = true;
        } else {
          this.validAdjData = [];
        }
      } else if (response && response.statusCode === 204) {
        this.savedAdjustmentId = 0;
        this.invalidAdjData = [];
        this.errorAdjData = [];
        this.validAdjData = [];
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  openUploadDialog() {
    this.createAdjDialog = true;
  }

  uploadEventHandler(e: UploadEvent) {
    const data = new AdjustmentFileData();
    data.userInfo = JSON.stringify(this.usersService.UserInfo());
    e.data = data;
    const token = sessionStorage.getItem('access_token');
    e.headers = e.headers.append('Authorization', 'Bearer ' + token);
  }

  uploadProgressEventHandler(e: UploadProgressEvent) {
    this.disableClose = true;
  }

  uploadSuccess(e: SuccessEvent) {
    const response = e.response;
    if (response && response.body && response.body.statusCode === 200) {
      this.isFileError = false;
      if (response.body.maxErrorExceeded) {
        this.maxErrorExceeded = true;
        this.adjustmetRecordId = response.body.payrollAdjId;
      } else {
        this.uploadComplete(response.body);
      }
    } else if (response && response.body && response.body.statusCode === 400) {
      this.createAdjDialog = false;
      this.fileErrorMsg = response.body.messageObj;
      this.isFileError = true;
    } else {
      this.notificationService.setErrorNotification();
    }
    this.disableClose = false;
    this.notificationService.setUpLoading(false);
  }

  continueUpload(action: any) {
    if (action === 'yes') {
      this.loading = true;
      this.savedAdjustmentId = this.adjustmetRecordId;
      this.uploadComplete('');
      this.notificationService.setUpLoading(true);
      this.getAdjustmentRecords(true);
    } else {
      this.deleteAdjReport();
    }
    this.maxErrorExceeded = false;
    this.createAdjDialog = false;
    this.loading = false;
  }

  selectEventHandler(e: SelectEvent) {
    const fileName = (e.files[0].name).substring(0, e.files[0].name.lastIndexOf('.') + 1);
    if (fileName.length > 200) {
      this.fileNameErrorMsg = this.config.MaxAdjFileNameErrorMsg;
      this.notificationService.setUpNotification({ success: false, message: this.fileNameErrorMsg });
      e.preventDefault();
    }
  }

  uploadComplete(uploadValue: any) {
    if (!this.maxErrorExceeded && uploadValue.payrollAdjId) {
      this.savedAdjustmentId = uploadValue.payrollAdjId;
      this.getAdjustmentRecords(true);
    }
    this.createAdjDialog = false;
    this.disableClose = false;
  }

  errorEventHandler() {
    this.msg = this.config.ErrorMessage;
    this.notificationService.setUpNotification({ success: false, message: this.msg });
    this.notificationService.setUpLoading(false);
    this.createAdjDialog = false;
  }

  closeCreateAdjDialog() {
    this.createAdjDialog = false;
    this.disableClose = false;
  }

  displayNotification(response: any, isCreated = false) {
    this.notificationService.setUpLoading(true);
    this.editAdjDataItem = {};
    this.isDataSaved.emit(true);
    this.savedAdjustmentId = response.payrollAdjustmentsId ? response.payrollAdjustmentsId : 0;
    if (response && response.message) {
      this.notificationService.setUpNotification({ success: true, message: response.message });
    }
    this.isNextVisible = false;
    this.getAdjustmentRecords(isCreated);
  }

  onAddEditClose(response: any, isCreated = false) {
    this.savedAdjustmentId = response.payrollAdjustmentsId ? response.payrollAdjustmentsId : 0;
    this.isNextVisible = false;
    this.getAdjustmentRecords(isCreated);
  }

  getFiscalYearList() {
    this.yearArray = [];
    this.allFiscalYears = [];
    const cfy: number = new Date().getFullYear() + (new Date().getMonth() + 1 > 6 ? 1 : 0);
    for (let i = this.config.minYear; i <= cfy; i++) {
      this.yearArray.push(i);
    }
    const arrOfStr = this.yearArray.map(num => {
      return String(num);
    });
    this.yearArray = arrOfStr.sort((a, b) => b - a);
    this.allFiscalYears = arrOfStr.slice();
  }

  addHandler(value: any) {
    this.getFiscalYearList();
    this.getPersonalDetailForm();
    this.isEditInvalidAdj = false;
    this.ssnVerifiationDialog = true;
    this.isEmpDetailValid = false;
    this.isNew = true;
  }

  handleFilter(value: any) {
    this.allFiscalYears = value ? this.yearArray.filter((s: any) => s.indexOf(value) !== -1)
      : this.yearArray;
  }

  onNewSsnChange(input: any) {
    this.isEmpDetailValid = false;
    this.ssnValue = input ? input.trim() : '';
    if (this.ssnValue.length === 9) {
      if (this.ssnPattern.test(this.ssnValue)) {
        this.searchBtnEnable = false;
        this.ssn = this.ssnValue;
      }
    }
    this.empNotFound = false;
  }

  FYChange(value: any) {
    if (value && this.personalDetailsForm.value.fiscalYear) {
      this.isEmpDetailValid = false;
      this.searchBtnEnable = false;
      this.selectedElements = [];
    }
  }

  async getFYSchedules(fy: number) {
    const inputData = { userInfo: this.usersService.UserInfo(), fiscalYear: +fy };
    await this.scheduleService.getScheduleList(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200 && response.result) {
        if (response.result.schedules && (response.result.schedules.length > 0 || response.result.schedules.length === 0)) {
          this.selectedFYSchedules = response.result;
        }
      } else {
        this.notificationService.setErrorNotification();
      }
      this.isEmpDetailValid = true;
      this.isProcessing = false;
      this.searchBtnEnable = true;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.isProcessing = false;
        this.searchBtnEnable = false;
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      });
  }

  searchEmployeeSsn() {
    this.isProcessing = true;
    const selectedFY = this.personalDetailsForm.value.fiscalYear;
    const inputData = { userInfo: this.usersService.UserInfo(), ssn: this.usersService.encrypt(this.ssn, 'post'), fiscalYear: selectedFY };
    this.adjustmentService.getEmployeeInfo(inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        if (data.result.length > 0) {
          this.gridData = data.result;
        } else {
          this.gridData = [];
        }
      } else if (data && data.statusCode === 204) {
        this.empNotFound = true;
        this.noContectMsg = data.message;
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.isProcessing = false;
        this.searchBtnEnable = true;
        this.notificationService.setErrorNotification();
      }, () => {
        this.getFYSchedules(selectedFY);
      }
    );
  }

  editHandler(data: any, isInvalid: boolean) {
    if (!isInvalid) {
      const fy = data.event.dataItem.fiscalYear;
      if (fy > 2016) {
        const inputData = { userInfo: this.usersService.UserInfo(), fiscalYear: fy };
        this.scheduleService.getScheduleList(inputData).subscribe((response: any) => {
          if (response && response.statusCode === 200 && response.result && response.result.schedules.length > 0) {
            this.selectedFYSchedules = response.result;
            this.adjModelDataItem = new AdjustmentRecord();
            this.adjModelDataItem = data.event;
            this.adjModelDataItem.fiscalYearScheduleList = this.selectedFYSchedules;
            this.adjModelDataItem.isInvalid = isInvalid;
            this.isNew = false;
            this.isNextVisible = true;
          } else {
            this.notificationService.setErrorNotification('No schedule found');
          }
        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.notificationService.setErrorNotification();
            this.notificationService.setUpLoading(false);
          });
      } else {
        this.adjModelDataItem = new AdjustmentRecord();
        this.adjModelDataItem = data.event;
        this.adjModelDataItem.fiscalYearScheduleList = [];
        this.adjModelDataItem.isInvalid = isInvalid;
        this.isNew = false;
        this.isNextVisible = true;
      }
    } else {
      this.adjModelDataItem = new AdjustmentRecord();
      this.adjModelDataItem = data.event;
      this.adjModelDataItem.fiscalYearScheduleList = !isInvalid ? this.selectedFYSchedules : [];
      this.adjModelDataItem.isInvalid = isInvalid;
      this.isNew = false;
      this.isNextVisible = true;
    }
    this.editAdjData = null;
  }

  editInvalidAdjRecords(value: boolean) {
    this.isEditInvalidAdj = value;
    this.getFiscalYearList();
    this.getPersonalDetailForm();
    this.ssnVerifiationDialog = true;
    this.isEmpDetailValid = false;
  }

  onEditNextClick(formData: any) {
    this.editAdjData = new EditAdjRecords();
    this.editAdjData = this.selectedElements[0];
    this.editAdjData.fullSSN = formData.value.ssn;
    this.editAdjData.fiscalYear = formData.value.fiscalYear;
    this.editAdjData.fiscalYearScheduleList = this.selectedFYSchedules;
    this.ssnVerifiationDialog = false;
  }

  onSelectionChange(event: any) {
    if (event.selectedRows.length > 0) {
      this.selectedElements.push(event.selectedRows[0].dataItem);
    }
    if (event.deselectedRows.length > 0) {
      const index = this.selectedElements.indexOf(event.deselectedRows[0].dataItem);
      this.selectedElements.splice(index, 1);
    }
  }

  onCancelClick(formData: any): void {
    this.ssnVerifiationDialog = false;
    this.isEmpDetailValid = false;
    this.isEditInvalidAdj = false;
    this.selectedElements = [];
  }

  onNextClick(formData: any) {
    this.adjModelDataItem = new AdjustmentRecord();
    this.adjModelDataItem.fiscalYear = formData.value.fiscalYear;
    this.adjModelDataItem = this.selectedElements[0];
    this.adjModelDataItem.adjustmentImportId = this.summaryData.adjustmentId;
    this.adjModelDataItem.fullSSN = formData.value.ssn;
    this.adjModelDataItem.fiscalYearScheduleList = this.selectedFYSchedules;
    this.ssnVerifiationDialog = false;
    this.isNextVisible = true;
  }

  deleteAdjReport() {
    this.notificationService.setUpLoading(true);
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      adjustmentId: this.adjustmetRecordId
    };
    this.adjustmentService.deleteAdjReport(inputData).subscribe(response => {
      if (response && response.success) {
        this.getAdjustmentRecords(true);
        this.notificationService.setUpNotification(response);
      } else if (response && !response.success) {
        this.notificationService.setUpNotification(response);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  deleteSelectedRecords(value: any) {
    this.deleteMasterAdjDialog = true;
    this.selectedData = value.selectedRecords;
  }

  deleteMasterAdjRecord() {
    this.loading = true;
    const allAdjRecordIds = this.selectedData.map(x => x.adjustmentRecordIds).join(",")
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      adjustmentId: this.savedAdjustmentId,
      adjRecordIds: allAdjRecordIds
    };
    this.adjustmentService.deleteAdjRecord(inputData).subscribe(response => {
      if (response && response.success) {
        this.deleteMasterAdjDialog = false;
        response.payrollAdjustmentsId = this.summaryData.adjustmentId;
        this.enableMasterDeleteBtn = false;
        this.displayNotification(response, true);
      } else {
        this.deleteMasterAdjDialog = false;
        this.notificationService.setUpNotification({ success: false, message: response.message });
      }
      this.loading = false;
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.loading = false;
        this.deleteMasterAdjDialog = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  onSave4LaterClick() {
    this.saveForLaterMsg = this.config.SaveForLaterMsg.replace('{0}', this.summaryData.adjustmentId);
    this.saveForLaterDialog = true;
  }

  onSaveAdjustmentClick() {
    this.loading = true;
    const response = { success: true, message: 'Adjustment is successfully Saved.' };
    setTimeout(() => {
      this.saveForLaterDialog = false;
      this.loading = false;
    }, 500);
    this.displayNotification(response, false);
  }

  submitAdjustment() {
    this.loading = true;
    const inputData = { userInfo: this.usersService.UserInfo(), adjustmentId: this.summaryData.adjustmentId };
    this.adjustmentService.submitV2Adjustments(inputData).subscribe(response => {
      if (response && response.statusCode === 200) {
        this.submitAdjDialog = false;
        this.displayNotification(response, false);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.loading = false;
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.loading = false;
        this.submitAdjDialog = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

}
